import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Coord } from '../../jscaip/Coord';
import { Ordinal } from '../../jscaip/Ordinal';
import { Player, PlayerOrNone } from '../../jscaip/Player';
import { EpaminondasHeuristic } from './EpaminondasHeuristic';
export class EpaminondasAttackHeuristic extends EpaminondasHeuristic {
    DOMINANCE_FACTOR = 20;
    DEFENSE_FACTOR = 5;
    TERRITORY_FACTOR = 2;
    OFFENSE_FACTOR = 10;
    CENTER_FACTOR = 5;
    MOBILITY_FACTOR = 0.12;
    getBoardValue(node, _config) {
        const state = node.gameState;
        const dominance = this.getDominance(state);
        const defense = this.getDefense(state);
        const territory = this.getTerritory(state);
        const center = this.getCenter(state);
        const winning = this.getOffense(state);
        const mobility = this.getMobility(state);
        return BoardValue.of(dominance + defense + territory + center + winning + mobility);
    }
    getDominance(state) {
        let score = 0;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            score += coordAndContent.content.getScoreModifier();
        }
        return score * this.DOMINANCE_FACTOR;
    }
    getDefense(state) {
        let score = 0;
        const width = state.getWidth();
        const height = state.getHeight();
        for (let x = 0; x < width; x++) {
            if (state.getPieceAtXY(x, height - 1) === Player.ZERO) {
                score += Player.ZERO.getScoreModifier();
            }
            if (state.getPieceAtXY(x, 0) === Player.ONE) {
                score += Player.ONE.getScoreModifier();
            }
        }
        return score * this.DEFENSE_FACTOR;
    }
    getTerritory(state) {
        let score = 0;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const owner = coordAndContent.content;
            for (let dx = -1; dx <= 1; dx++) {
                for (let dy = -1; dy <= 1; dy++) {
                    const coord = coordAndContent.coord.getNext(new Coord(dx, dy), 1);
                    if (state.hasPieceAt(coord, owner)) {
                        score += 1 * owner.getScoreModifier();
                    }
                    else if (state.hasPieceAt(coord, PlayerOrNone.NONE)) {
                        score += 1 * owner.getScoreModifier();
                    }
                }
            }
            score -= owner.getScoreModifier();
        }
        return score * this.TERRITORY_FACTOR;
    }
    getOffense(state) {
        let score = 0;
        const width = state.getWidth();
        const height = state.getHeight();
        for (let x = 0; x < width; x++) {
            if (state.getPieceAtXY(x, 0) === Player.ZERO) {
                score += Player.ZERO.getScoreModifier();
            }
            if (state.getPieceAtXY(x, height - 1) === Player.ONE) {
                score += Player.ONE.getScoreModifier();
            }
        }
        return score * this.OFFENSE_FACTOR;
    }
    getCenter(state) {
        let score = 0;
        const width = state.getWidth();
        const cx = (width - 1) / 2;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const owner = coordAndContent.content;
            score += owner.getScoreModifier() * Math.abs(coordAndContent.coord.x - cx);
        }
        return score * this.CENTER_FACTOR;
    }
    getMobility(state) {
        let score = 0;
        let biggestZero = 0;
        let biggestOne = 0;
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const firstCoord = coordAndContent.coord;
            const owner = coordAndContent.content;
            for (const direction of Ordinal.ORDINALS) {
                let phalanxSize = 1;
                let nextCoord = firstCoord.getNext(direction, 1);
                while (state.hasPieceAt(nextCoord, owner)) {
                    phalanxSize += 1;
                    nextCoord = nextCoord.getNext(direction, 1);
                }
                let stepSize = 1;
                while (stepSize <= phalanxSize &&
                    state.hasPieceAt(nextCoord, PlayerOrNone.NONE)) {
                    stepSize++;
                    nextCoord = nextCoord.getNext(direction, 1);
                }
                score += (stepSize * stepSize) * owner.getScoreModifier();
                if (owner === Player.ZERO) {
                    biggestZero = Math.max(biggestZero, stepSize);
                }
                else if (owner === Player.ONE) {
                    biggestOne = Math.max(biggestOne, stepSize);
                }
            }
        }
        return (score +
            biggestZero * Player.ZERO.getScoreModifier() +
            biggestOne * Player.ONE.getScoreModifier()) * this.MOBILITY_FACTOR;
    }
}
